/*
 * Lib Module Chats
 */

Lib.Chat = (function () {
    var self = {};

    $(Lib).on('document.ready', function () {
        self.bindOrderButtons();

        $('div.chat-new-message-submit').on('click', function () {
            $(this).find('.is-icon').addClass('animated fadeOutRight');
            $('form[data-chat-form]').submit();
        });
    });

    self.refresh = function () {
        $("div.chat").each(function () {
            var currentChat = $(this);
            var loaderHolder = currentChat.parent();
            Lib.Loader.show(loaderHolder);
            $.get({
                url: '',
                dataType: 'html',
                success: function (response) {
                    Lib.Loader.hide(loaderHolder);
                    var chatContent = $(response).find('.chat');
                    currentChat.replaceWith(chatContent);
                }
            })
        });
    };


    self.bindOrderButtons = function () {
        $(document).on('click', '[data-chat-set-order]', function () {
            var order = $(this).data('chat-set-order');
            Lib.Loader.show();
            $.ajax({
                type: 'POST',
                url: Lib.Format.url({
                    controller: 'users',
                    action: 'change_setting.json'
                }),
                dataType: 'json',
                data: {
                    data: {
                        setting: 'Global.consultation.order',
                        value: order
                    }
                },
                success: function () {
                    Lib.Util.reload();
                }
            });
        });
    };


    return self;

})();
